import { render, staticRenderFns } from "./EditCustomerUserModal.vue?vue&type=template&id=0c9509a7&scoped=true"
import script from "./EditCustomerUserModal.vue?vue&type=script&lang=ts"
export * from "./EditCustomerUserModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9509a7",
  null
  
)

export default component.exports